module.exports = __webpack_public_path__ + "static/media/greydot-icon.09b1d995.png";